import DIApi from './_diApi';

class BudgetChapterAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetChapters';
}

export default new BudgetChapterAPI();
